export const bulkUsers = (() => {
  return process.env.BULK_USERS.split(' ')
})()
